import React from 'react';
import propTypes from 'prop-types';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import Statuses from 'tailwind-components/CarrierAppointments/Statuses';
import CommissionsTabs from './CommissionsTabs';
import useBelowBreakpoint from 'hooks/useBelowBreakpoint';
import useFlexRowWrapped from 'hooks/useFlexRowWrapped';
import { cn } from 'lib/utils';

export default function CommissionsStickyHeader({
  title,
  currentTab,
  setCurrentTab,
  handleResetActiveCarrier
}) {
  const isBelowLg = useBelowBreakpoint('lg');
  const isLgAndUp = !isBelowLg;
  const [headerRowRef, isHeaderRowWrapped] = useFlexRowWrapped(isLgAndUp);
  const statusesCompactLayout = isBelowLg || isHeaderRowWrapped;

  return (
    <div
      ref={headerRowRef}
      className='sticky top-0 z-30 flex shrink-0 flex-col flex-wrap gap-4 rounded-xl bg-white p-4 shadow-md lg:flex-row lg:flex-wrap lg:items-start lg:justify-between'
    >
      <SimpleContainer className='max-w-full'>
        <h2 className='m-0 bg-white text-left text-2xl font-semibold text-gray-900 max-lg:text-center'>
          {title}
        </h2>
        <CommissionsTabs
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          handleResetActiveCarrier={handleResetActiveCarrier}
        />
      </SimpleContainer>

      <SimpleContainer
        className={cn(
          'shrink-0',
          statusesCompactLayout ? 'w-full' : 'items-end'
        )}
      >
        <Statuses
          reverse={!statusesCompactLayout}
          containerClassName={cn(
            'flex-row justify-between',
            statusesCompactLayout && 'w-full',
            !statusesCompactLayout && 'lg:flex-col'
          )}
        />
      </SimpleContainer>
    </div>
  );
}

CommissionsStickyHeader.propTypes = {
  title: propTypes.string.isRequired,
  currentTab: propTypes.string.isRequired,
  setCurrentTab: propTypes.func.isRequired,
  handleResetActiveCarrier: propTypes.func.isRequired
};
